import React, { useEffect, useState } from "react";
import API from "../../services/api";
import Select from "react-select";
import { BrandsTypes } from "../../utils/constants";
import { getReportLastDay, getReportMonthTimestamps } from "./reportDateUtils";

function ComparisonReport(props) {
  const { month, year, newReports } = props;
  const [previousMonthData, setPreviousMonthData] = useState([]);
  const [presentMonthData, setPresentMonthData] = useState([]);
  const [currentDay, setCurrentDay] = useState(31);
  const [differenceTotal, setDifferenceTotal] = useState(0);
  const [previousTotal, setPreviousTotal] = useState(0);
  const [presentTotal, setPresenTotal] = useState(0);
  const [selectedBrandType, setSelectedBrandType] = useState([2, 3, 5, 7, 9, 10, 11, 12, 13]);

  function getDaysInMonth(year, month) {
    return getReportLastDay(year, month);
  }
  function getPreviousMonth(currentYear, currentMonth) {
    const currentDate = new Date(currentYear, currentMonth - 1, 1); // Month is zero-based

    // Set the date to the last day of the previous month
    currentDate.setDate(0);

    // Get the year and month of the previous month
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth() + 1; // Month is zero-based, so we add 1

    return { year, month };
  }
  function getStartAndEndOfMonthTimestamps(year, month) {
    return getReportMonthTimestamps(year, month);
  }
  const previousMonth = getPreviousMonth(year, month);
  function getMonthName(monthNumber) {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    // Ensure the month number is within a valid range
    if (monthNumber >= 1 && monthNumber <= 12) {
      return months[monthNumber - 1];
    } else {
      return "Invalid month number";
    }
  }

  const fetchData = async () => {
    try {
      let res = await API({
        url: "/reports/comparison-reports",
        method: "POST",
        responseType: "json",
        data: {
          previous: getStartAndEndOfMonthTimestamps(
            previousMonth.year,
            previousMonth.month
          ),
          present: getStartAndEndOfMonthTimestamps(year, month),
          newReport: newReports,
          brand_type: selectedBrandType
        },
      });
      if (res.code === 200) {
        setPreviousMonthData(res?.data?.previousMonthData);
        setPresentMonthData(res?.data?.presentMonthData);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const handleCurrentDay = () => {
    setCurrentDay(getDaysInMonth(year, month - 1));
  };

  const fetchSpent = (month, year, index, from = "present") => {
      let { startTimestamp } = getStartAndEndOfMonthTimestamps(year, month);
      startTimestamp = startTimestamp + index * 86400;
      if (from === "previous") {
        for (let i = 0; i < previousMonthData.length; i++) {
          if (previousMonthData[i].date === startTimestamp) {
            return previousMonthData[i].totalSpent || 0;
          }
        }
        return 0;
      } else {
        for (let i = 0; i < presentMonthData.length; i++) {
          if (presentMonthData[i].date === startTimestamp) {
            return presentMonthData[i].totalSpent || 0;
          }
        }
        return 0;
      }
  };

  const calaculateDifference = (
    thisMonth,
    thisYear,
    prevMonth,
    prevYear,
    index,
    from = "difference"
  ) => {
    const previousSpent = fetchSpent(prevMonth, prevYear, index, "previous");
    const presentSpent = fetchSpent(thisMonth, thisYear, index);
    if (from === "class") {
      return presentSpent > previousSpent ? false : true;
    } else {
      return presentSpent - previousSpent;
    }
  };

  const calculateTotals = () => {
    let sumPrevious = 0;
    let sumPresent = 0;
    for (let i = 0; i < currentDay; i++) {
      sumPrevious += fetchSpent(previousMonth.month, previousMonth.year, i, "previous");
      sumPresent += fetchSpent(month, year, i);
    }
    setPreviousTotal(sumPrevious);
    setPresenTotal(sumPresent);
    setDifferenceTotal(sumPresent - sumPrevious);
  };

  useEffect(() => {
    fetchData();
    handleCurrentDay();
  }, [year, month, newReports, selectedBrandType]);

  useEffect(() => {
    calculateTotals();
  }, [presentMonthData, previousMonthData]);

  return (
    <div className="report-image">
      <h3 id="comparison-h4">Month Wise Revenue Comparison</h3>
      <Select
        isMulti
        options={BrandsTypes}
        value={BrandsTypes.filter(option => selectedBrandType.includes(option.value))}
        onChange={(selectedOptions) => setSelectedBrandType(selectedOptions.map(opt => opt.value))}
        placeholder="Select Brand Type(s)"
        className="mb-1"
      />
      <div className="overflow-x-auto">
        <table
          className="table table-bordered report-table"
          id="comparison-table"
        >
          <thead>
            <tr>
              <th>Day</th>
              <th>{getMonthName(previousMonth.month)}-{previousMonth.year}</th>
              <th>{getMonthName(month)}-{year}</th>
              <th>Difference</th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: currentDay }, (_, index) => (
              <tr key={index}>
                <td>{`${index + 1}`}</td>
                <td title={parseFloat(fetchSpent(previousMonth.month, previousMonth.year, index, "previous")).toFixed(2)}>
                  {Math.round(fetchSpent(
                    previousMonth.month,
                    previousMonth.year,
                    index,
                    "previous"
                  ))}
                </td>
                <td title={parseFloat(fetchSpent(month, year, index)).toFixed(2)}>{Math.round(fetchSpent(month, year, index))}</td>
                <td
                  title={parseFloat(calaculateDifference(month, year, previousMonth.month, previousMonth.year, index)).toFixed(2)}
                  className={
                    calaculateDifference(
                      month,
                      year,
                      previousMonth.month,
                      previousMonth.year,
                      index,
                      "class"
                    )
                      ? "negative-difference"
                      : "positive-difference"
                  }
                >
                  {Math.round(
                    calaculateDifference(
                      month,
                      year,
                      previousMonth.month,
                      previousMonth.year,
                      index
                    )
                  )}
                </td>
              </tr>
            ))}
            <tr>
              <td className="total-color-comparison">Grand Total</td>
              <td className="total-color-comparison" title={parseFloat(previousTotal).toFixed(2)}>
                {Math.round(previousTotal)}
              </td>
              <td className="total-color-comparison" title={parseFloat(presentTotal).toFixed(2)}>
                {Math.round(presentTotal)}
              </td>
              <td
                title={parseFloat(differenceTotal).toFixed(2)}
                className={
                  differenceTotal > 0
                    ? "positive-difference"
                    : "negative-difference"
                }
              >
                {Math.round(differenceTotal)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ComparisonReport;
